import { Divider } from '@mui/material';
import { TextUI } from './Text';

export type DividerProps = {
  label: string
};

export const DividerUI: React.FC<DividerProps> = ({ label }) => {
  return (
    <Divider>
      <div style={{ paddingRight: '15px', paddingLeft: '15px' }}>
        <TextUI size="body2" color="grey">{label}</TextUI>
      </div>
    </Divider>
  );
};
